import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import NormalInput2 from "../../components/inputs/NormalInput2";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import ImageUploadInput from "../../components/inputs/ImageUploadInput";
import { useGoBack } from "../../utils";
import { useCommercialHooks } from "../../hooks/useCommercialHooks";
import VideoUploadInput from "../../components/inputs/VideoUploadInput";
import { useGetPlacesHooks } from "../../hooks/useGetPlacesHooks";
import { useTranslation } from "../../languages";
import ThankYouModal from "../../components/modals/ThankYouModal";
import StripePaymentModal from "../../components/modals/StripePaymentModal";
import { toast } from "react-toastify";
import { useState } from "react";
const AddComercials = () => {
  const goBack = useGoBack();
  const {
    //all local states
    commercialData,
    setCommercialData,
    placeNameDropdownData,
    setClientSecret,clientSecret,
    stripeModalOpen,setStripeModalOpen,
    //validation
    isFormValid,
    //all functions
    onPressPayNowBtn,
  } = useCommercialHooks();
  const { placesData} = useGetPlacesHooks();
  const { t } = useTranslation();
  const [thankYouModalOpen,setThankYouModalOpen]=useState(false);
  return (
    <div>
      <Container fluid>
        <Header title={t("commercials")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-7 color-primary-blue m-0 figma-font-h5">
            {t("addNewCommercial")}
          </h5>
          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            {t("close")}
          </Button>
        </div>
        <Card className="border-none figma-card-radius p-0">
          <CardBody className="padding-top-42px padding-left-42px padding-right-42px">
            <Row style={{ "--bs-gutter-y": "1.5rem" }}>
              <Col md={6}>
                <NormalInput2
                  placeholder={t("writeName")}
                  value={commercialData?.name}
                  setValue={(v) =>
                    setCommercialData((prev) => ({ ...prev, name: v }))
                  }
                  label={t("enterCommericalsName")}
                />
              </Col>
              <Col md={6}>
                <MultiSelectInput
                  label={t("enterYourPlaceName")}
                  setValue={(v) =>
                    setCommercialData((prev) => ({ ...prev, place: v }))
                  }
                  options={placesData}
                  value={commercialData?.place ?? []}
                  obj={true}
                />
              </Col>
              <Col md={6}>
                <MultiSelectInput
                  label={t("types")}
                  setValue={(v) =>
                    setCommercialData((prev) => ({ ...prev, types: v }))
                  }
                  options={[
                    "activity",
                   
                    "other",
                  ]}
                  value={commercialData?.types ?? []}
                />
              </Col>
              <Col md={12}>
                <NormalInput2
                  label={t("enterDescription")}
                  type={"textarea"}
                  placeholder={t("writeDescription")}
                  value={commercialData?.description ?? ""}
                  setValue={(v) =>
                    setCommercialData((prev) => ({ ...prev, description: v }))
                  }
                />
              </Col>
              <Col xl={4} md={6}>
                <div className="mt-3  flex-wrap justify-content-end gap-2">
                  <Label
                    style={{ marginBottom: "0.9rem" }}
                    className="figma-input-label d-block"
                  >
                    {t("addMedia")}
                  </Label>
                  <div style={{ width: "100%", maxWidth: "200px" }}>
                    <VideoUploadInput
                      noPadding={true}
                      hideShadow={true}
                      id={"place-video"}
                      setValue={(v) =>
                        console.log(v) ||
                        setCommercialData((prev) => ({
                          ...prev,
                          mediaUrl: v,
                        }))
                      }
                      value={commercialData?.mediaUrl}
                    />
                  </div>
                </div>
              </Col>
              <div className="mt-5 mb-2 text-center">
                <Button
                  style={{ maxWidth: "380px" }}
                  onClick={onPressPayNowBtn}
                  className="standard-rounded-btn full-width"
                  disabled={!isFormValid}
                >
                  {t("payNow")}
                </Button>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Container>
      {/* thank you modal */}
      <ThankYouModal
        isOpen={thankYouModalOpen}
        setisOpen={setThankYouModalOpen}
      />
      <StripePaymentModal
        isOpen={stripeModalOpen}
        toggle={() => setStripeModalOpen(!stripeModalOpen)}
        clientSecret={clientSecret}
        onPaymentSuccess={() => {
          setThankYouModalOpen(true); // show thank you modal
          setStripeModalOpen(false); // close payment modal
          toast.success("Commercial added successfully ! ");
        }}
      />
    </div>
  );
};
export default AddComercials;
